import angular from 'angular';
import stGlobalPreloaderComponent from './stGlobalPreloader.component';
import sharedService from '../../services/shared.service';
let stGlobalPreloaderModule = angular.module('stGlobalPreloader', [
  sharedService
])

.component('stGlobalPreloader', stGlobalPreloaderComponent)
.name;

export default stGlobalPreloaderModule;



// WEBPACK FOOTER //
// ./client/app/common/stGlobalPreloader/stGlobalPreloader.js